import Vue from "vue";
import {
  NavBar,
  Icon,
  Field,
  Button,
  Notify,
  NumberKeyboard,
  Form,
  CellGroup,
  SwipeCell,
  Cell,
  Picker,
  Uploader,
  Popup,
  AddressEdit,
  Area,
  Calendar,
  Image,
  Lazyload,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Loading,
  Search ,List 
} from "vant";
Vue.use(NavBar)
  .use(Icon)
  .use(Field)
  .use(Button)
  .use(Area)
  .use(Notify)
  .use(Picker)
  .use(NumberKeyboard)
  .use(Form)
  .use(CellGroup)
  .use(Popup)
  .use(SwipeCell)
  .use(Uploader)
  .use(AddressEdit)
  .use(Calendar)
  .use(Image)
  .use(Lazyload, {
    error: "http://static.ledouya.com/FmPcZOnxBEpHLA-rsU-fXCV7qjx9",
  })
  .use(RadioGroup)
  .use(Radio)
  .use(Cell)
  .use(Checkbox)
  .use(CheckboxGroup).use(Search).use(List )
  .use(Loading);
export default Vue;
